import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { Avatar } from "@element-plus/icons-vue"
import ComAvatar from "@/components/layout/header/ComAvatar.vue"
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ComAvatarButton',
  setup(__props) {

const show = ref(false)


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_el_popover, {
      width: 350,
      trigger: "click",
      onShow: _cache[0] || (_cache[0] = ($event: any) => (show.value = true)),
      onHide: _cache[1] || (_cache[1] = ($event: any) => (show.value = false))
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Avatar))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (show.value)
          ? (_openBlock(), _createBlock(ComAvatar, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})